<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    :loading-text="$t('loading')"
    class="ordera-box-shadow striped-table"
    mobile-breakpoint="0"
  >
    <template v-slot:[`item.company_id`]="{ item }">
      <div v-if="item.company_id" class="text-body-2">
        {{ getCompanyName(item.company_id) }}
      </div>
    </template>

    <template v-slot:[`item.restaurant_id`]="{ item }">
      <div v-if="item.restaurant_id" class="text-body-2">
        {{ getRestaurantName(item.restaurant_id) }}
      </div>
    </template>

    <template v-slot:[`item.params.limit_definition.active`]="{ item }">
      <div class="text-body-2">
        {{ getLimitTypeLabel(item.params.limit_definition?.active) }}
      </div>
    </template>

    <template v-slot:[`item.params.timing.active`]="{ item }">
      <v-chip small outlined>
        {{ getTimeLimitLabel(item.params.timing?.active) }}
      </v-chip>
    </template>

    <template v-slot:[`item.params.payment_logic.active`]="{ item }">
      <div class="text-body-2">
        {{ getWhoPaysLabel(item.params.payment_logic?.active) }}
      </div>
    </template>

    <template v-slot:[`item.params.ordering_rules.active`]="{ item }">
      <div class="text-body-2">
        {{ getWhatCanOrderLabel(item.params.ordering_rules?.active) }}
      </div>
    </template>

    <template v-slot:item.state="{ item }">
      <v-switch
        v-model="item.state"
        :disabled="!canEdit(item)"
        dense
        hide-details
        true-value="active"
        false-value="inactive"
        @change="$emit('toggle', item)"
      />
    </template>

    <template v-slot:item.actions="{ item }">
      <div class="d-flex justify-end" style="gap: 4px">
        <circle-button
          v-if="canEdit(item)"
          icon="mdi-pencil"
          @click="$emit('edit', item)"
          :tooltip="$t('edit')"
          small
        />
        <circle-button
          v-else
          icon="mdi-lock"
          @click="$emit('edit', item)"
          :tooltip="$t('limit_not_editable_in_company')"
          small
        />
        <circle-button
          v-if="canEdit(item)"
          icon="mdi-delete"
          @click="$emit('delete', item)"
          color="error"
          :tooltip="$t('delete')"
          small
        />
      </div>
    </template>

    <template v-slot:no-data>
      <slot name="no-data" />
    </template>
  </v-data-table>
</template>

<script>
import setLang from "@/mixins/setLang";
import {
  getLimitTypeLabelKey,
  getTimeLimitLabelKey,
  getWhoPaysLabelKey,
  getWhatCanOrderLabelKey,
} from "@/utils/limitHelpers";

export default {
  name: "LimitsDataTable",
  mixins: [setLang],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    restaurants: {
      type: Array,
      default: () => [],
    },
    companies: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Function,
      default: () => true,
    },
  },
  methods: {
    getCompanyName(id) {
      const company = this.companies.find((c) => Number(c.id) === Number(id));
      return company ? this.toLatin(company.name) : String(id || "");
    },
    getRestaurantName(id) {
      if (Number(id) === 0) return this.$t("all_restaurants") || "Svi restorani";
      const restaurant = this.restaurants.find((r) => Number(r.id) === Number(id));
      return restaurant ? this.toLatin(restaurant.name) : String(id || "");
    },
    getLimitTypeLabel(type) {
      const key = getLimitTypeLabelKey(type);
      return key ? this.$t(key) : type || "";
    },
    getTimeLimitLabel(type) {
      const key = getTimeLimitLabelKey(type);
      return key ? this.$t(key) : type || "";
    },
    getWhoPaysLabel(type) {
      const key = getWhoPaysLabelKey(type);
      return key ? this.$t(key) : type || "";
    },
    getWhatCanOrderLabel(type) {
      if (Array.isArray(type)) {
        if (type.length === 0) return "";
        return type
          .map((t) => {
            const key = getWhatCanOrderLabelKey(t);
            return key ? this.$t(key) : "";
          })
          .filter(Boolean)
          .join(", ");
      }
      const key = getWhatCanOrderLabelKey(type);
      return key ? this.$t(key) : type || "";
    },
  },
};
</script>
